/* Maxias Custom JS created on 20 Mar 2025 */
$(document).ready(function() {
  if ($('body').hasClass('custom-processed')) {
    return false;
  }

  // Close the cart drawer via overlay.
  $('body').on('click', '#CartDrawer-Overlay', function() {
    $('cart-drawer').find('button.drawer__close').click();
  });
  
  // Automation on some tasks.
  setTimeout(function() {
    // Replace grid for product listing.
    if (screen.width <= 420) {
      $("#product-grid").removeClass('grid product-grid grid--2-col-tablet-down').addClass('grid product-grid grid--1-col-tablet-down');
    }
    
    // Activate first category in the list.
    $('div.category-list a.product-type-filter:first-child').trigger('click');
    
    // Rename Buy now button.  
    $('button.shopify-payment-button__button.shopify-payment-button__button--unbranded').html('Buy now');

    // Listen to cart update event on product page.
    //if ($('body').find('product-info').length || $('body').find('.template-search').length) {
      custom_on_cart_update();
    //}
  }, 400);

  //if ($('body').find('#shopify-section-template--24244692058479__main').length) {
    // Listen to product recommendations.
    //custom_on_product_recommendation_load();
  //}

  // Make menu hover.
  $('a.header__icon--account[is-login="1"]').click(function(e) {
    e.preventDefault();

    //var account_link = $(this).attr('href');
    
    if (!$('#custom-menu-account-wrapper').length) {
      var account_menu = '<div id="custom-menu-account-wrapper" class="hide">';
      //account_menu += '<div class="custom-menu-item"><a href="https://shopify.com/90332823919/account/profile">My account</a></div>';
      //account_menu += '<div class="custom-menu-item"><a href="https://shopify.com/90332823919/account/orders">My purchase</a></div>';
      account_menu += '<div class="custom-menu-item"><a href="/account">My account</a></div>';
      account_menu += '<div class="custom-menu-item"><a href="/account">My purchase</a></div>';
      account_menu += '<div class="custom-menu-item"><a href="/pages/faq">FAQ</a></div>';
      account_menu += '<div class="custom-menu-item"><a href="/account/logout">Logout</a></div>';
      account_menu += '</div>';

      $(this).after(account_menu);
    }

    $('#custom-menu-account-wrapper').hide().removeClass('hide').fadeIn();
    return false;
  });

  // Close account menu if click outside.
  $('body').click(function(e) {
    if (!$(e.target).is("#custom-menu-account-wrapper") && $("#custom-menu-account-wrapper").is(':visible')) {
      $('#custom-menu-account-wrapper').fadeOut();
      return true;
    }
  });

  // Processed once.
  $('body').addClass('custom-processed');
});

// Trigger on product recommendation load.
function custom_on_product_recommendation_load() {
  if (!window.fetch || typeof window.fetch !== "function") return;

  console.log('custom_on_product_recommendation_load: called!');

  const originalFetch = window.fetch;
  window.fetch = function () {
    const response = originalFetch.apply(this, arguments);
    console.log(arguments);
    
    if (arguments[0].indexOf('/recommendations/products') == 0) {
      response.then((res) => {
        setTimeout(function() {
          customer_swiper_activate('swiper-template--24244692058479__related-products');
        }, 400);
      });
    }

    return response;
  };
}

// Activate a swiper.
function customer_swiper_activate(swiper_id) {
  //console.log('customer_swiper_activate: ' + swiper_id);

  if (!jQuery('body').find('#' + swiper_id).length) {
    //console.log('Not found. Retry in 1s.');

    setTimeout(function() {
      customer_swiper_activate(swiper_id);
    }, 1000);

    return false;
  }
  
  var swiper = new Swiper('#' + swiper_id, {
    slidesPerView: 4,
    spaceBetween: 8,
    autoplay: false,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      enabled: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      420: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4
      }
    }
  });
}

// Validate s Shopify URL.
function custom_is_shopify_cart_URL(url) {
  var ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
    "/cart/add.js",
    "/cart/update.js",
    "/cart/change.js",
    "/cart/clear.js",
  ];

  if (!url) return false;
  const path = url.split("/").pop();
  return ShopifyCartURLs.includes(`/cart/${path}`);
}

// Trigger on cart update.
function custom_on_cart_update() {
  //console.log('custom_on_cart_update 0');
  
  if (!window.fetch || typeof window.fetch !== "function") return;
  
  //console.log('custom_on_cart_update 1');
  
  const originalFetch = window.fetch;
  window.fetch = function () {
    const response = originalFetch.apply(this, arguments);
    //console.log('custom_on_cart_update 2');
    //console.log(arguments);

    if (custom_is_shopify_cart_URL(arguments[0])) {      
      response.then((res) => {
        res.clone().json().then((data) => custom_dispatch_event(res.url, data));
      });
    }
      
    return response;
  };
}

// Handle cart update event.
function custom_dispatch_event(url, detail) {
  /*
  console.log('custom_dispatch_event 0');
  console.log(url);
  console.log(detail);
  */
  
  // Update cart icon buble and cart drawer.
  var cart_icon = jQuery(detail['sections']['cart-icon-bubble']);
  jQuery('#cart-icon-bubble').html(cart_icon.html());
  
  //console.log('custom_dispatch_event 1');

  var cart_drawer = jQuery(detail['sections']['cart-drawer']);
  jQuery('cart-drawer').html(cart_drawer.find('cart-drawer').html());
  
  //console.log('custom_dispatch_event 2');

  if (cart_drawer.find('.drawer__inner-empty').length) {
    jQuery('cart-drawer').addClass('is-empty');
  }
  else{
    jQuery('cart-drawer').removeClass('is-empty');
  }
  
  return false;
}

// Open the drawer cart.
function custom_add_to_cart(obj) {
  // Add to cart if the number is one.
  var current_quantity = jQuery(obj).prev().find('input.quantity__input').val();
  if (current_quantity == 1) {
    // Add to cart.
    jQuery(obj).prev().find('input.quantity__input').val('0');
    jQuery(obj).prev().find('button.quantity__button[name="plus"]').trigger('click');

    setTimeout(function() {
      jQuery('cart-drawer').addClass('drawer animate active');
    }, 1000);
  }
  else{
    jQuery('cart-drawer').addClass('drawer animate active');
  }
}

// Filter by product type.
function custom_product_type_filter(obj, type) {
  jQuery(obj).parent().children('.active').removeClass('active');
  jQuery(obj).addClass('active');

  const product_types = {
    'kaya': 'shopify-section-template--24244691894639__featured_collection',
    'condiments': 'shopify-section-template--24244691894639__featured_collection_78zrmb',
    'festive': 'shopify-section-template--24244691894639__featured_collection_xWFVjw',
    'others': 'shopify-section-template--24244691894639__featured_collection_tpMtWi',
  };

  if (product_types[type] != null) {
    // Hide all.
    jQuery('#shopify-section-template--24244691894639__featured_collection').removeClass('active');
    jQuery('#shopify-section-template--24244691894639__featured_collection_78zrmb').removeClass('active');
    jQuery('#shopify-section-template--24244691894639__featured_collection_xWFVjw').removeClass('active');
    jQuery('#shopify-section-template--24244691894639__featured_collection_tpMtWi').removeClass('active');

    // Show the selection.
    jQuery('#' + product_types[type]).addClass('active');

    // Check to init slide if not yet.
    if (document.getElementById(product_types[type]).swiper == null) {
      var swiper_id = jQuery('#' + product_types[type]).find('.swiper').attr('id');
      customer_swiper_activate(swiper_id);
      /*
      var swiper = new Swiper('#' + swiper_id, {
        slidesPerView: 4,
        spaceBetween: 8,
        autoplay: false,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          enabled: true
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          360: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          820: {
            slidesPerView: 4
          }
        }
      });
      */
    }
  }

  return false;
}
